// Product Image Zoom with Full-Screen Overlay (Mobile & Desktop)
document.addEventListener('DOMContentLoaded', function() {
    const mainImage = document.querySelector('.main-product-image');
    if (!mainImage) return;

    // Check if device is mobile
    function isMobile() {
        return window.innerWidth <= 768 || ('ontouchstart' in window);
    }

    let zoomOverlay = null;
    let overlayImage = null;
    let currentZoom = 1;
    let currentPanX = 0;
    let currentPanY = 0;
    let initialDistance = 0;
    let isPinching = false;
    let isPanning = false;
    let lastPanX = 0;
    let lastPanY = 0;
    let startPanX = 0;
    let startPanY = 0;
    let initialZoomOnPinch = 1;

    // Create zoom overlay
    function createOverlay() {
        if (zoomOverlay) return;

        // Create overlay container
        zoomOverlay = document.createElement('div');
        zoomOverlay.className = 'product-zoom-overlay';
        zoomOverlay.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.95);
            z-index: 9999;
            display: none;
            justify-content: center;
            align-items: center;
            touch-action: none;
        `;

        // Create close button
        const closeBtn = document.createElement('button');
        closeBtn.className = 'zoom-close-btn';
        closeBtn.innerHTML = '✕';
        closeBtn.style.cssText = `
            position: absolute;
            top: 20px;
            right: 20px;
            background: rgba(255, 255, 255, 0.9);
            border: none;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            font-size: 24px;
            cursor: pointer;
            z-index: 10000;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #000;
        `;
        closeBtn.addEventListener('click', closeOverlay);

        // Create help text (desktop only)
        const helpText = document.createElement('div');
        helpText.className = 'zoom-help-text';
        helpText.innerHTML = 'Use mouse wheel to zoom • Drag to pan';
        helpText.style.cssText = `
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            background: rgba(0, 0, 0, 0.7);
            color: white;
            padding: 8px 16px;
            border-radius: 20px;
            font-size: 14px;
            z-index: 10000;
            pointer-events: none;
            display: none;
        `;
        
        // Show help text only on desktop
        if (!isMobile()) {
            helpText.style.display = 'block';
        }

        // Create image container
        const imageContainer = document.createElement('div');
        imageContainer.style.cssText = `
            width: 100%;
            height: 100%;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
        `;

        // Create image element
        overlayImage = document.createElement('img');
        overlayImage.style.cssText = `
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            transform-origin: center center;
            transition: transform 0.1s ease-out;
            user-select: none;
            -webkit-user-select: none;
        `;

        imageContainer.appendChild(overlayImage);
        zoomOverlay.appendChild(closeBtn);
        zoomOverlay.appendChild(helpText);
        zoomOverlay.appendChild(imageContainer);
        document.body.appendChild(zoomOverlay);

        // Add touch event listeners (mobile)
        overlayImage.addEventListener('touchstart', handleTouchStart, { passive: false });
        overlayImage.addEventListener('touchmove', handleTouchMove, { passive: false });
        overlayImage.addEventListener('touchend', handleTouchEnd, { passive: false });
        
        // Add mouse event listeners (desktop)
        overlayImage.addEventListener('mousedown', handleMouseDown);
        overlayImage.addEventListener('mousemove', handleMouseMove);
        overlayImage.addEventListener('mouseup', handleMouseUp);
        overlayImage.addEventListener('mouseleave', handleMouseUp);
        overlayImage.addEventListener('wheel', handleWheel, { passive: false });
        
        // Close on background click
        zoomOverlay.addEventListener('click', function(e) {
            if (e.target === zoomOverlay) {
                closeOverlay();
            }
        });
    }

    // Open overlay
    function openOverlay() {
        createOverlay();
        
        // Set the image source
        overlayImage.src = mainImage.src;
        
        // Reset zoom and pan
        currentZoom = 1;
        currentPanX = 0;
        currentPanY = 0;
        applyTransform();
        
        // Show overlay
        zoomOverlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        
        // Set initial cursor
        updateCursor();
    }

    // Close overlay
    function closeOverlay() {
        if (zoomOverlay) {
            zoomOverlay.style.display = 'none';
            document.body.style.overflow = '';
            
            // Reset zoom and pan
            currentZoom = 1;
            currentPanX = 0;
            currentPanY = 0;
            applyTransform();
        }
    }

    // Apply zoom and pan transform
    function applyTransform() {
        if (!overlayImage) return;
        
        const transform = `translate(${currentPanX}px, ${currentPanY}px) scale(${currentZoom})`;
        overlayImage.style.transform = transform;
        overlayImage.style.transition = isPinching || isPanning ? 'none' : 'transform 0.1s ease-out';
    }

    // Apply zoom level
    function applyZoom(zoomLevel, centerX, centerY) {
        const oldZoom = currentZoom;
        currentZoom = Math.max(1, Math.min(5, zoomLevel)); // Limit between 1x and 5x
        
        // Adjust pan to zoom towards the pinch center
        if (centerX !== undefined && centerY !== undefined && overlayImage) {
            const rect = overlayImage.getBoundingClientRect();
            const imageCenter = {
                x: rect.left + rect.width / 2,
                y: rect.top + rect.height / 2
            };
            
            // Calculate the offset from center
            const offsetX = centerX - imageCenter.x;
            const offsetY = centerY - imageCenter.y;
            
            // Adjust pan based on zoom change
            const zoomRatio = currentZoom / oldZoom;
            currentPanX = currentPanX * zoomRatio + offsetX * (1 - zoomRatio);
            currentPanY = currentPanY * zoomRatio + offsetY * (1 - zoomRatio);
        }
        
        // Reset pan when zooming out to 1x or below
        if (currentZoom <= 1) {
            currentPanX = 0;
            currentPanY = 0;
        } else {
            constrainPan();
        }
        
        applyTransform();
    }

    // Constrain pan within boundaries
    function constrainPan() {
        if (currentZoom <= 1 || !overlayImage) {
            currentPanX = 0;
            currentPanY = 0;
            return;
        }
        
        const container = overlayImage.parentElement.getBoundingClientRect();
        const imageRect = overlayImage.getBoundingClientRect();
        
        // Calculate the scaled dimensions
        const scaledWidth = imageRect.width * currentZoom / (overlayImage.style.transform.includes('scale') ? 1 : currentZoom);
        const scaledHeight = imageRect.height * currentZoom / (overlayImage.style.transform.includes('scale') ? 1 : currentZoom);
        
        // Calculate max pan distances
        const maxPanX = Math.max(0, (scaledWidth - container.width) / 2);
        const maxPanY = Math.max(0, (scaledHeight - container.height) / 2);
        
        // Constrain pan within boundaries
        currentPanX = Math.max(-maxPanX, Math.min(maxPanX, currentPanX));
        currentPanY = Math.max(-maxPanY, Math.min(maxPanY, currentPanY));
    }

    // Apply pan
    function applyPan(panX, panY) {
        if (currentZoom <= 1) return; // Don't pan when not zoomed
        
        currentPanX = panX;
        currentPanY = panY;
        
        constrainPan();
        applyTransform();
    }

    // Calculate distance between two touch points
    function getDistance(touch1, touch2) {
        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    // Get center point between two touches
    function getTouchCenter(touch1, touch2) {
        return {
            x: (touch1.clientX + touch2.clientX) / 2,
            y: (touch1.clientY + touch2.clientY) / 2
        };
    }

    // Touch event handlers
    function handleTouchStart(e) {
        if (e.touches.length === 2) {
            // Pinch zoom start
            initialDistance = getDistance(e.touches[0], e.touches[1]);
            initialZoomOnPinch = currentZoom;
            isPinching = true;
            isPanning = false;
            e.preventDefault();
        } else if (e.touches.length === 1 && currentZoom > 1) {
            // Single touch pan start
            isPanning = true;
            isPinching = false;
            const touch = e.touches[0];
            startPanX = touch.clientX;
            startPanY = touch.clientY;
            lastPanX = currentPanX;
            lastPanY = currentPanY;
            e.preventDefault();
        }
    }

    function handleTouchMove(e) {
        if (e.touches.length === 2 && isPinching) {
            e.preventDefault();
            
            const currentDistance = getDistance(e.touches[0], e.touches[1]);
            const scale = currentDistance / initialDistance;
            const center = getTouchCenter(e.touches[0], e.touches[1]);
            
            const newZoom = initialZoomOnPinch * scale;
            applyZoom(newZoom, center.x, center.y);
            
        } else if (e.touches.length === 1 && isPanning && currentZoom > 1) {
            e.preventDefault();
            const touch = e.touches[0];
            
            const deltaX = touch.clientX - startPanX;
            const deltaY = touch.clientY - startPanY;
            
            const newPanX = lastPanX + deltaX;
            const newPanY = lastPanY + deltaY;
            
            applyPan(newPanX, newPanY);
        }
    }

    function handleTouchEnd(e) {
        if (e.touches.length === 0) {
            initialDistance = 0;
            isPinching = false;
            isPanning = false;
        } else if (e.touches.length === 1 && isPinching) {
            // Transition from pinch to pan
            isPinching = false;
            isPanning = true;
            const touch = e.touches[0];
            startPanX = touch.clientX;
            startPanY = touch.clientY;
            lastPanX = currentPanX;
            lastPanY = currentPanY;
        }
    }

    // Mouse event handlers (desktop)
    function handleMouseDown(e) {
        if (currentZoom > 1) {
            isPanning = true;
            startPanX = e.clientX;
            startPanY = e.clientY;
            lastPanX = currentPanX;
            lastPanY = currentPanY;
            overlayImage.style.cursor = 'grabbing';
            e.preventDefault();
        }
    }

    function handleMouseMove(e) {
        if (isPanning && currentZoom > 1) {
            e.preventDefault();
            
            const deltaX = e.clientX - startPanX;
            const deltaY = e.clientY - startPanY;
            
            const newPanX = lastPanX + deltaX;
            const newPanY = lastPanY + deltaY;
            
            applyPan(newPanX, newPanY);
        }
    }

    function handleMouseUp(e) {
        if (isPanning) {
            isPanning = false;
            updateCursor();
        }
    }

    // Mouse wheel zoom (desktop)
    function handleWheel(e) {
        e.preventDefault();
        
        const delta = e.deltaY > 0 ? -0.2 : 0.2;
        const newZoom = currentZoom + delta;
        
        // Get mouse position relative to the image
        const rect = overlayImage.getBoundingClientRect();
        const mouseX = e.clientX;
        const mouseY = e.clientY;
        
        applyZoom(newZoom, mouseX, mouseY);
        updateCursor();
    }

    // Update cursor based on zoom level
    function updateCursor() {
        if (!overlayImage) return;
        
        if (currentZoom > 1) {
            overlayImage.style.cursor = 'grab';
        } else {
            overlayImage.style.cursor = 'zoom-in';
        }
    }

    // Add click listener to main image
    mainImage.addEventListener('click', function(e) {
        e.preventDefault();
        openOverlay();
    });

    // Add visual indicator that image is clickable
    mainImage.style.cursor = 'pointer';
    
    // Update overlay image when main image changes
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
                if (overlayImage && zoomOverlay && zoomOverlay.style.display === 'flex') {
                    overlayImage.src = mainImage.src;
                    currentZoom = 1;
                    currentPanX = 0;
                    currentPanY = 0;
                    applyTransform();
                }
            }
        });
    });
    
    observer.observe(mainImage, { attributes: true });
});
